import axios from "@/api/axiosInstance";
import {
  FetchRosterManagementReportParams,
  FetchRosterManagementReportResponse,
} from "./types";

export const fetchRosterManagementReport = async (
  params: FetchRosterManagementReportParams = {},
): Promise<FetchRosterManagementReportResponse> => {
  const response = await axios.get<FetchRosterManagementReportResponse>(
    "/api/private/reports/roster-management",
    { params },
  );
  return response.data;
};
